import EventEmitter from "../../../node_modules/eventemitter3/index";
import mermaid from "../../../node_modules/mermaid/dist/mermaid";
let svgPanZoom = require('svg-pan-zoom')
import { WorkFlowChartClient } from "../client/Client";
import events from "../Events/EventList";
let $plantillaFormularId = <HTMLSelectElement>document.querySelector("#plantillaId");
export default class FlowChartComponent{
    $chart = <HTMLDivElement>document.getElementById("workflow");
    /**
     *
     */
    constructor(private flowChartClient: WorkFlowChartClient, private eventEmiter: EventEmitter) {
        mermaid.mermaidAPI.initialize({ startOnLoad: false });
        this.renderChart();
        this.init();
    }

    init = async ()=>{
        this.eventEmiter.on(events.STAGE_CREATED, this.renderChart)
        this.eventEmiter.on(events.STAGE_DELETED, this.renderChart)
        this.eventEmiter.on(events.STAGE_UPDATED, this.renderChart)

        this.eventEmiter.on(events.TRANSITION_CREATED, this.renderChart)
        this.eventEmiter.on(events.TRANSITION_DELETED, this.renderChart)
        this.eventEmiter.on(events.TRANSITION_UPDATED, this.renderChart)
        this.eventEmiter.on(events.PLANTILLA_ID_CHANGED, this.renderChart)
    }

    renderChart = async ()=>{
        try{
            var content = await this.flowChartClient.get(parseInt($plantillaFormularId.value));


            const insertSvg = (svgCode, bindFunctions)=>{
                this.$chart.innerHTML = svgCode.replace(/[ ]*max-width:[ 0-9\.]*px;/i, '');

            }
            const graph = await mermaid.mermaidAPI.render('graphDiv', content, insertSvg);

            svgPanZoom('#graphDiv', {
                zoomEnabled: true,
                controlIconsEnabled: true,
                fit: true,
                center: true
            })

            this.$chart.textContent 

        }catch(ex){
            console.log(ex);
            Notify.error("Error al renderizar flujo");
        }
    }
}